@if (showMain()) {
<main>
  <router-outlet></router-outlet>
</main>

<p
  class="build-stamp text-body-secondary small px-2 py-1 mb-0 text-end user-select-all"
  [attr.title]="buildStampTitle"
  role="status"
>
  Build {{ buildInfo.buildNumber }} · {{ buildRevisionLabel }} · v{{ buildInfo.packageVersion }}
</p>
} @else {
<div class="d-flex min-vh-100 align-items-center justify-content-center bg-body-secondary">
  <div class="text-center">
    <div class="spinner-border text-primary mb-3" role="status">
      <span class="visually-hidden">Validando sessão</span>
    </div>
    <p class="text-body-secondary small mb-0">Validando sessão...</p>
  </div>
</div>
}

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
  <p style="color: white">Carregando...</p>
</ngx-spinner>
